module.exports = __webpack_public_path__ + "img/5cfbe29.png";